import { IPbjsBid } from './prebid.types';
import { AD_SERVERS } from '../../configs/constants';
import { IDetection } from '../../uanc.types';

// lista adserwerów obsługujących prebid
export const AdServers_Supported_Prebid: AD_SERVERS[] = [AD_SERVERS.DFP];

export const prebidAdapterNames: string[] = [
    'adform',
    // 'adrino',
    'appnexus',
    'criteo',
    'ix',
    'pubmatic',
    'rtbhouse',
    'rubicon',
    'smartadserver',
    'sspBC',
    'teads',
];
export const adaptersMap: Record<string, () => Promise<any>> = {
    adform: () => import(/* webpackChunkName: "adfBidAdapter" */ 'prebid.js/modules/adfBidAdapter'),
    // adrino: () => import(/* webpackChunkName: "adrinoBidAdapter" */ 'prebid.js/modules/adrinoBidAdapter'),
    appnexus: () => import(/* webpackChunkName: "appnexusBidAdapter" */ 'prebid.js/modules/appnexusBidAdapter'),
    criteo: () => import(/* webpackChunkName: "criteoBidAdapter" */ 'prebid.js/modules/criteoBidAdapter'),
    ix: () => import(/* webpackChunkName: "ixBidAdapter" */ 'prebid.js/modules/ixBidAdapter'),
    pubmatic: () => import(/* webpackChunkName: "pubmaticBidAdapter" */ 'prebid.js/modules/pubmaticBidAdapter'),
    rtbhouse: () => import(/* webpackChunkName: "rtbhouseBidAdapter" */ 'prebid.js/modules/rtbhouseBidAdapter'),
    rubicon: () => import(/* webpackChunkName: "rubiconBidAdapter" */ 'prebid.js/modules/rubiconBidAdapter'),
    smartadserver: () => import(/* webpackChunkName: "smartadserverBidAdapter" */ 'prebid.js/modules/smartadserverBidAdapter'),
    sspBC: () => import(/* webpackChunkName: "sspBCBidAdapter" */ 'prebid.js/modules/sspBCBidAdapter'),
    teads: () => import(/* webpackChunkName: "teadsBidAdapter" */ 'prebid.js/modules/teadsBidAdapter'),
};

export const prebidModuleNames: string[] = [
    'currency',
    'paapi',
    'paapiForGpt',
    'justIdSystem',
    'teadsIdSystem',
    'userId',
    'consentManagementGpp',
    'consentManagementTcf',
    'gptPreAuction',
    'tcfControl',
    'schain',
];
export const modulesMap: Record<string, () => Promise<any>> = {
    currency: () => import(/* webpackChunkName: "currencyModule" */ 'prebid.js/modules/currency'),
    paapi: () => import(/* webpackChunkName: "paapiModule" */ 'prebid.js/modules/paapi'),
    paapiForGpt: () => import(/* webpackChunkName: "paapiModule" */ 'prebid.js/modules/paapiForGpt'),
    justIdSystem: () => import(/* webpackChunkName: "justIdSystem" */ 'prebid.js/modules/justIdSystem'),
    teadsIdSystem: () => import(/* webpackChunkName: "teadsIdSystem" */ 'prebid.js/modules/teadsIdSystem'),
    userId: () => import(/* webpackChunkName: "userId" */ 'prebid.js/modules/userId'),
    consentManagementGpp: () => import(/* webpackChunkName: "consentManagementGpp" */ 'prebid.js/modules/consentManagementGpp'),
    consentManagementTcf: () => import(/* webpackChunkName: "consentManagementTcf" */ 'prebid.js/modules/consentManagementTcf'),
    gptPreAuction: () => import(/* webpackChunkName: "gptPreAuction" */ 'prebid.js/modules/gptPreAuction'),
    tcfControl: () => import(/* webpackChunkName: "tcfControl" */ 'prebid.js/modules/tcfControl'),
    schain: () => import(/* webpackChunkName: "schain" */ 'prebid.js/modules/schain'),
};

const commonBidParams: IPbjsBid[] = [
    { bidder: 'criteo', params: { networkId: 2697, pubid: '110713' } },
    { bidder: 'rtbhouse', params: { region: 'prebid-eu', publisherId: 'oScqvFoFcqVeQET3ISu3' } },
    { bidder: 'sspBC', params: { publisherId: '449' } },
];
export const NATIVE_SGP: { [key: string]: IPbjsBid[] } = {
    box_moto_2: [...commonBidParams, { bidder: 'adrino', params: { hash: '7dd757bb49acaf5a98eaf000c79374aa' } }],
    box_gotowanie: [...commonBidParams, { bidder: 'adrino', params: { hash: '56c386e173cfd0d1ddae20a37d82f298' } }],
    box_ntgrymen_2: [...commonBidParams, { bidder: 'adrino', params: { hash: '7b0915fea1fd8493d01ac7f88ee41af3' } }],
    box_plotki: [...commonBidParams, { bidder: 'adrino', params: { hash: 'd77fbed0deee7bd33278ce166b7dbf30' } }],
    box_plotki_2: [...commonBidParams, { bidder: 'adrino', params: { hash: '289ff702b7c1c7fcccfa35ad996426ca' } }],
    box_popkultura_2: [...commonBidParams, { bidder: 'adrino', params: { hash: 'a2bfc0b7ffe35b26ef027599d0d5bbfc' } }],
    box_stylzycia_3: [...commonBidParams, { bidder: 'adrino', params: { hash: '7af8fb536d00b2b00d7a28e4b6ab32f4' } }],
    box_wydarzenia: [...commonBidParams, { bidder: 'adrino', params: { hash: '1624a07eaf1bf0bfbd6bb6c826417b37' } }],
};

export const PREBID_DSA = [
    '44520695/17interia/smaker',
    '44520695/17interia/deccoria3',
    '44520695/17interia/maxmodels',
    '44520695/17interia/czateria',
    '44520695/17interia/bryk',
    '44520695/17interia/opracownia',
    '44520695/17interia/poczta_logowanie',
];

export const JUSTTAG_OFF = ['www.twojapogoda.pl', 'naekranie.pl', '4fun.tv', '4funkids.pl', 'stacja7.pl'];

export const nativeObject = {
    sendTargetingKeys: false,
    image: {
        sendId: true,
        required: true,
        sizes: [350, 216],
    },
    title: {
        sendId: true,
        required: true,
        len: 30,
    },
    sponsoredBy: {
        sendId: true,
        required: false,
    },
    body: {
        sendId: true,
        required: false,
    },
    icon: {
        sendId: true,
        required: false,
        sizes: [50, 50],
    },
};

export const nativeObjectPOCZTA = (detection: IDetection): { [key: string]: any } => ({
    sendTargetingKeys: false,
    image: {
        sendId: true,
        required: true,
        sizes: [350, 216],
    },
    title: {
        sendId: true,
        required: true,
        len: 80,
    },
    sponsoredBy: {
        sendId: true,
        required: true,
    },
    body: {
        sendId: true,
        required: true,
    },
    icon: {
        sendId: true,
        required: true,
        sizes: [40, 40],
    },
    privacyLink: {
        sendId: true,
        required: true,
    },
    privacyIcon: {
        sendId: true,
        required: true,
    },
    rendererUrl: `${detection.protocol}//${detection.libraryPath}renderer.js`,
});

export const NOT_SUPPORTED_IX_SIZES = [
    [1220, 200],
    [1220, 300],
    [1220, 400],
    [1220, 600],
    [1, 1],
    [300, 125],
    [300, 200],
    [320, 125],
    [320, 75],
    [336, 400],
    [480, 200],
    [560, 100],
    [560, 200],
    [600, 100],
    [600, 200],
    [600, 300],
    [600, 400],
    [600, 450],
    [620, 100],
    [620, 200],
    [625, 100],
    [700, 100],
    [940, 200],
    [940, 300],
    [950, 100],
    [950, 150],
    [950, 200],
    [950, 300],
    [970, 100],
    [970, 200],
    [985, 200],
    [985, 300],
    [985, 400],
    [985, 485],
    [985, 600],
];

export const NATIVE_SLOTS = ['box_sidebar', 'rectangle_news', 'gora_srodek', 'box300x250'];
export const NATIVE_SLOTS_POCZTA = ['message', 'message_2', 'message_3', 'message_4'];

export const NATIVE_SERVICES = [
    '44520695/17interia/sgp2021',
    '44520695/17interia/sgp2021_b',
    '44520695/17interia/kobieta',
    '44520695/17interia/gry',
    '44520695/17interia/pomponik',
    '44520695/17interia/ukraina',
    '44520695/17interia/fakty',
    '44520695/17interia/film',
    '44520695/17interia/muzyka',
    '44520695/17interia/moto',
    '44520695/17interia/biznes',
    '44520695/17interia/geekweek',
    '44520695/17interia/styl24',
    '44520695/17interia/porady',
    '44520695/17interia/zdrowie',
    '44520695/17interia/sport',
    '44520695/17interia/zielona',
    '44520695/17interia/esporter',
    '44520695/17interia/historia',
    '44520695/17interia/swiatseriali',
    '44520695/17interia/polska2041',
    '44520695/17interia/pomagam',
    '44520695/17interia/pogoda',
    '44520695/17interia/huba',
    '44520695/17interia/encyklopedia',
    '44520695/17interia/ros',
    '44520695/17interia/default',
    '44520695/17interia/programtv',
    '44520695/17interia/twojapogoda',
    '44520695/17interia/starter',
];

export const NATIVE_BIDDERS = ['sspBC', 'rtbhouse', 'criteo'];
export const NATIVE_BIDDERS_WITH_PARAMS = ['appnexus', 'ix'];
export const NATIVE_BIDDERS_PARAMS_NAME: { [key: string]: string } = {
    appnexus: 'placementId',
    ix: 'siteId',
};
export const NATIVE_PARAMS: { [key: string]: { [key: string]: string } } = {
    ix: {
        box300x250: '941126',
        box_sidebar: '941123',
        gora_srodek: '941125',
        rectangle_news: '941124',
    },
    appnexus: {
        box300x250: '29057626',
        box_sidebar: '29057627',
        gora_srodek: '29057628',
        rectangle_news: '29057629',
    },
};
